import { Injectable } from '@angular/core';
import { ParserService } from './parser.service';

@Injectable({
  providedIn: 'root',
})
export class StringParserService<T = string> extends ParserService<T> {
  public parse(value: T): string {
    return value as string;
  }

  public unparse(value: string): T {
    return value as T;
  }
}
